import { Form } from "antd";

import "./Filters.css"
import {ListOfOperator} from "../../../Login/LoginForm/ListOfOperators/ListOfOperator";
import React from "react";
import {isNil} from "lodash";
import {Employee} from "../../../../models/Auth/Employee";
import {OperatorType} from "../../../../models/OperatorType";

export interface FilterOperatorProps{
    onChange?:(value:string)=>void
    onDeselect?:(value:any)=>void
    onClear?:()=>void
    required?:boolean,
    customRequiredText?:string,
    label?:string,
    placeholder?:string,
    dataKey:string,
}

export function FilterOperator(props:FilterOperatorProps){
    const rules=[{ required: props.required ?? false, message: props.customRequiredText ? props.customRequiredText : 'Il campo è obbligatorio' }]

    return  <>
        <Form.Item name={props.dataKey} label={props.label} rules={rules}>
            <Form.Item noStyle shouldUpdate>
                {({ getFieldValue, setFieldsValue }) => (
                    <ListOfOperator
                        id="1"
                        operatorTypes={[OperatorType.OPERATOR]}
                        onSelected={(option: any, operator: Employee | undefined) => {
                            if (operator?.name) {
                                setFieldsValue({ [props.dataKey]: operator.name });
                            }
                        }}
                        onClear={() => {
                            setFieldsValue({ [props.dataKey]: undefined });
                        }}
                        onChangeOperator={(value:string|undefined) => {
                            if(typeof value === 'string' && (value === '')){
                                setFieldsValue({ [props.dataKey]: undefined });
                            }else{
                                setFieldsValue({ [props.dataKey]: value });
                            }
                        }}
                    />
                )}
            </Form.Item>
        </Form.Item>


    </>

}